import omit from 'lodash/omit';
import { deepKeysToCamel } from 'js-utils/transformation';

import {
    events as eventsDuck,
    collections as collectionsDuck,
} from '@eb/destination-utils';

const {
    utils: { transformForRedux },
} = eventsDuck;

const {
    utils: { transformCollectionResponse },
} = collectionsDuck;

const _formatCollectionEntity = ({ followStatus = {}, ...collection }) => ({
    isFollowing: followStatus.followedByYou,
    ...omit(collection, 'image'),
});

const transformAndUpdateEventsReducerKeys = (events) => {
    const {
        events: transformedEvents,
        ...transformedResponse
    } = transformForRedux(events);

    return {
        entities: {
            ...transformedEvents,
        },
        upcoming: {
            ...omit(transformedResponse, 'hasMoreItems'),
        },
    };
};

export const getInitialState = ({
    facebookOptions,
    events,
    shareUrl,
    secret,
    userCollections,
    featureFlags,
    collectionCreatorImageOverrideUrl,
    getCollectionEventsWithSearch,
    collection: collectionEntity,
    user: { publicId, isAuthenticated },
    env: {
        isMobile,
        serverUrl,
        currencyFormat,
        ebDomain: domain,
        localeInfo: {
            twitter_handle: twitterHandle,
            facebook_locale: facebookLocale,
            facebook_page: facebookPage,
        },
    },
    gaSettings,
}) => {
    // We have both image and image_large, take out
    // image since we're not using it to avoid confusion
    const formattedCollectionEntity = _formatCollectionEntity(
        deepKeysToCamel(collectionEntity),
    );

    let eventsToUse = events;

    // For editorial collections the event's response shape is different. So this
    // takes that into account before adding to the events reducer.
    if (events && events.collection_events && events.collection_events.length) {
        eventsToUse = {
            ...events,
            events: events.collection_events.map(
                ({ event, ...customCollectionProps }) => ({
                    ...event,
                    ...customCollectionProps,
                }),
            ),
        };
    }

    const configGetCollectionEventsWithSearch =
        getCollectionEventsWithSearch && !formattedCollectionEntity.isQuality;

    return {
        events: transformAndUpdateEventsReducerKeys(eventsToUse),
        collections: transformCollectionResponse(userCollections),
        collection: {
            secret,
            shareUrl,
            getCollectionEventsWithSearch: configGetCollectionEventsWithSearch,
            displayCreatorImageUrl: collectionCreatorImageOverrideUrl,
            ...formattedCollectionEntity,
        },
        domain,
        currencyFormat,
        featureFlags,
        userId: publicId,
        shareOptions: {
            isMobile,
            twitterHandle,
            serverUrl,
            facebookOptions: {
                ...facebookOptions,
                locale: facebookLocale,
                page: facebookPage,
            },
        },
        gaSettings,
        isAuthenticated,
    };
};
